// extracted by mini-css-extract-plugin
module.exports = {"slider":"lR","lightBg":"lS","sliderLink":"lT","sliderTitle":"lU","sliderTitleSelected":"lV","centerMenu":"lW"};